// import './CubeFaceIcon.css';

const FACES = {
  top: "12,2 21,7 12,12 3,7",
  front: "3,7 12,12 12,22 3,17",
  right: "21,7 12,12 12,22 21,17",
  bottom: "12,12 3,17 12,22 21,17",
  left: "12,12 12,2 3,7 3,17",
  back: "12,12 12,2 21,7 21,17",
};

export default function CubeFaceIcon({ face, size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeWidth={1.5}
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {/* highlighted face */}
      <polygon points={FACES[face]} fill="black" stroke="black" />

      {/* outline */}
      <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />

      {/* visible inner edges */}
      <path d="M12 12 L3 7 M12 12 L21 7 M12 12 L12 22" />

      {/* hidden edges */}
      <path
        d="M12 12 L12 2 M12 12 L3 17 M12 12 L21 17"
        strokeDasharray="2 2"
        opacity={0.6}
      />
    </svg>
  );
}